module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-310x310-780238c1a9d3b3df37d669d9405b8ffc.png";